import { EventStatus } from 'routes/referral/types/event-detail-api.types';

import { CustomEventAction, EventListItem } from '../types/events.types';

/**
 * Build a client-injected "custom event" (Wheel of Fortune, Daily Rewards,
 * quiz, …) as an `EventListItem` so it renders through the same EventCard / tabs
 * / filters as API events. Pure factory — no data fetching — so it stays unit
 * testable.
 */
export const createCustomEvent = (
  overrides: Partial<EventListItem> & { id: number; name: string; _customAction: CustomEventAction },
): EventListItem => ({
  event_type: 'referral',
  event_label: null,
  tagline: '',
  description: '',
  image_url: null,
  banner_url: null,
  icon_url: null,
  visible: true,
  start_datetime: new Date().toISOString(),
  end_datetime: new Date().toISOString(),
  status: EventStatus.ONGOING,
  registration_start_datetime: new Date().toISOString(),
  registration_end_datetime: new Date().toISOString(),
  is_registration_open: false,
  list_mode: 'open',
  participant_count: 0,
  is_active: true,
  rewards: [],
  ...overrides,
});
